export const IMAGES: { [key: string]: string } = {
    search_icon: '/assets/images/seach.svg',
    home_icon: '/assets/images/home.svg',
    edit_icon: '/assets/images/edit.svg',
    cardedit_icon: '/assets/images/cardedit.svg',
    duplicate_icon: '/assets/images/duplicate.svg',
    comforce_icon: '/assets/images/comforce.svg',
    comtrack_icon: '/assets/images/comtrack.svg',
    conversional_icon: '/assets/images/conversional-ai.svg',
    caret_icon: '/assets/images/caret.svg',
    booking_slot_icon: '/assets/images/booking-slot.svg',
    agent1_icon: '/assets/images/agent1.svg',
    agent2_icon: '/assets/images/agent2.svg',
    agent3_icon: '/assets/images/agent3.svg',
};